module.exports = __webpack_public_path__ + "static/media/1-7.f052f5e3.mp3";